import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("sf_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || "Er is iets misgegaan.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return String(detail);
}

export function humanBytes(n) {
    if (!n && n !== 0) return "—";
    const u = ["B", "KB", "MB", "GB", "TB"];
    let i = 0;
    let f = Number(n);
    while (f >= 1024 && i < u.length - 1) {
        f /= 1024;
        i += 1;
    }
    return `${f.toFixed(f < 10 ? 2 : 1)} ${u[i]}`;
}

export function gb(n) {
    return (Number(n) / 1024 ** 3).toFixed(2);
}
